module.exports = __webpack_public_path__ + "static/img/complaint.98a1836.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/complaint.png
// module id = DYJ6
// module chunks = 1